import { useAppStore } from "~/store/AppModule";

interface UseSupportChatReturn {
  openSC: () => void;
  closeSC: () => void;
  toggleSC: () => void;
}

export const useSupportChat = (): UseSupportChatReturn => {
  const store = useAppStore();

  const openSC = () => {
    store.showSupportChatModal = true;
  }
  const closeSC = () => {
    store.showSupportChatModal = false;
  }
  const toggleSC = () => {
    store.showSupportChatModal = !store.showSupportChatModal;
  }

  return {
    openSC,
    closeSC,
    toggleSC,
  }
}